export default {
  freeTimesLimitTitle: 'انتهت النسخة التجريبية المجانية للحساب اليوم.',
  fileSizeLimitTitle: 'لا يمكن أن تتجاوز أحجام الملفات للحسابات المجانية 20MB.',
  total: 'الإجمالي',
  enterCode: 'أدخل الرمز',
  signUpToPurchaseBtn: 'أنشئ حسابًا للشراء',
  goPurchseBtn: 'اذهب إلى الشراء',
  saveTips: 'وفر حتى {{num}}%',
  discount: 'خصم',
  weekly: 'أسبوعي',
  montly: 'سنويًا',
  yearly: 'شهريًا',
  week: 'أسبوع',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYearly: '$3.75',
  billMonth: '29.99 دولارًا شهريًا',
  billYear: '179.99 دولارًا سنويًا',
  AlreadySubscribe: 'مشترك بالفعل؟',
  vipTips1: 'لا يوجد حد لحجم الملف',
  vipTips2: 'عدد غير محدود من الملفات التي تمت معالجتها',
  vipTips3: 'تغيير غير محدود لخلفية الصورة',
  vipTips4: 'استخدم جميع الأدوات المجانية والميزات المتميزة',
  purchaseTips: 'التجديد تلقائيًا والإلغاء في أي وقت.',
  tips: 'نصائح:',
  promoCodeInvalidTips: 'رمزك الترويجي غير صالح',
};
